import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'

const UnidadMedidaApp = lazy(() => import('./view/UnidadMedida'))

export const unidadMedidaRouteMap = {
  gestion: {
    path: '/unidadmedida/gestion',
    name: 'Unidades de medida',
    action: 'UNIDADES_DE_MEDIDA',
  },
  registro: {
    path: '/unidadmedida/nuevo',
    name: 'Nueva unidad medida',
    action: 'ADMINISTRAR_UNIDAD_MEDIDA',
  },
  actualizar: {
    path: '/unidadmedida/actualizar/:id',
    name: 'Actualizar unidad medida',
    action: 'ADMINISTRAR_UNIDAD_MEDIDA',
  },
}
const unidadMedidaRoutes = [
  {
    path: unidadMedidaRouteMap.gestion.path,
    element: (
      <OperacionesProvider>
        <UnidadMedidaApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]
export default unidadMedidaRoutes
